import React from 'react'

import { Outline } from '@cinch/oxd-components/button/src'
import { Cross } from '@cinch/oxd-components/icons/src'
import SVG from '@cinch/oxd-components/svg/src'
import Text, { TextStyles } from '@cinch/oxd-components/text/src'
import tokens from '@cinch/oxd-utils/tokens/src'

import * as defaultCardStyles from './card.module.css'

interface CardProps {
  children?: React.ReactNode
  title?: string | React.ReactNode
  cardStyles?: any
  closeText?: string

  onClose?: (e: any) => void
}

const Card: React.FC<CardProps> = ({ children, title = '', onClose, closeText, cardStyles, ...props }) => {
  const styles = cardStyles || defaultCardStyles

  return (
    <div className={styles.card} {...props} data-id="card">
      {(title || onClose) && (
        <div className={styles.title}>
          <Text type={TextStyles.cardTitle} element="h5">
            {title}
          </Text>
          {onClose && !closeText && (
            <button title="Close" onClick={onClose} className={styles.close}>
              <SVG children={Cross} size={tokens.customProperties.font.size['3xl']} />
            </button>
          )}
          {onClose && closeText && (
            <Outline size="mini" onClick={onClose} type="button">
              {closeText}
            </Outline>
          )}
        </div>
      )}
      <div className={styles.body} data-id="card-body">
        {children}
      </div>
    </div>
  )
}

export default Card
